// extracted by mini-css-extract-plugin
export default {"collapse":"collapseM4M_collapse__KnXMI"};